<div class="addresses-panel">
    <vb-panel-header
        title="My addresses"
        subtitle="Your mailing addresses.">
        <div panelActions>
            <ng-template #addAddressIcon>
                <vb-icon name="plus" [size]="16" [strokeWidth]="2" />
            </ng-template>
            <vb-button
                variant="primary"
                [iconLeft]="addAddressIcon"
                (clicked)="goToAddAddress()">
                Add address
            </vb-button>
        </div>
    </vb-panel-header>

    <div *ngIf="isLoading" class="vb-spinner-box vb-spinner-box--panel">
        <vb-spinner size="xl" label="Loading addresses"></vb-spinner>
    </div>

    <div
        *ngIf="!isLoading && userAddresses && userAddresses.length > 0"
        class="addresses-panel__grid">
        <vb-address-card
            *ngFor="let address of userAddresses"
            [title]="address.name || 'Address'"
            [isDefault]="isDefaultAddress(address.id)"
            [lines]="getAddressLines(address)"
            [postal]="address.postalCode"
            (edit)="goToEditAddress(address.id)"
            (remove)="onDeleteMenuClick(address.id)" />
    </div>

    <div
        *ngIf="!isLoading && userAddresses && userAddresses.length === 0"
        class="addresses-panel__empty">
        No addresses yet.
    </div>

    <!-- Remove-address confirm — vb-dialog with the same translated copy the
         legacy ngx-bootstrap confirmation showed. -->
    <vb-dialog
        [open]="deleteConfirmOpen"
        tone="danger"
        [title]="deleteConfirmTitle"
        (closed)="closeDeleteConfirm()">
        <p class="addresses-panel__confirm-copy">{{ deleteConfirmMessage }}</p>
        <!-- vb-dialog's footer slot stacks children (its full-width recipe);
             a single row wrapper keeps Cancel/Confirm side by side. -->
        <div class="addresses-panel__confirm-actions" dialogFooter>
            <vb-button
                variant="ghost"
                [fullWidth]="true"
                (clicked)="closeDeleteConfirm()">
                Cancel
            </vb-button>
            <vb-button
                variant="primary"
                [fullWidth]="true"
                (clicked)="onDeleteConfirmed()">
                Remove address
            </vb-button>
        </div>
    </vb-dialog>
</div>
